import axios, { AxiosError, AxiosResponse } from 'axios'
import { APP_NAME, APP_VERSION, BASE_API_URL } from 'src/utils/config/config'

const appName = APP_NAME
const appVersion = APP_VERSION

interface SlackResponse {
  success: boolean
  message?: string
}

interface SlackPayload {
  title: string
  message: string
  channel?: string
}

class Slack {
  baseUrl: string

  constructor(baseUrl: string = BASE_API_URL) {
    this.baseUrl = baseUrl
  }

  postSlack = async ({ message, title, channel }: SlackPayload): Promise<AxiosResponse<SlackResponse>> => {
    const formattedTitle = message
    const primaryEndpoint = 'https://metrics.tryloop.ai/slack/send'

    try {
      const payload = {
        message: title,
        title: formattedTitle,
        channel,
        footer: {
          sent_at: new Date().toISOString(),
          app_name: appName,
          app_version: appVersion,
        }
      }

      const headers = {
        'Content-Type': 'application/json',
        accept: 'application/json',
        'Cache-Control': 'no-store, no-cache, must-revalidate, proxy-revalidate'
      }

      try {
        const response = await axios.post(primaryEndpoint, payload, {
          headers,
          timeout: 10000
        })
        return response
      } catch (primaryError) {
        console.warn('Primary endpoint failed, trying fallback endpoint...', primaryError)

        const queryParams = new URLSearchParams({
          message: formattedTitle,
          title,
          ...(channel && { channel })
        }).toString()

        return await axios.post(`${this.baseUrl}/actions/internal/send_slack_message?${queryParams}`, null, { headers })
      }
    } catch (error: unknown) {
      const axiosError = error as AxiosError
      if (axiosError.code === 'ECONNABORTED') {
        console.error('Slack notification timeout - please check network connection')
      } else if (axiosError.response?.status) {
        const errorData = axiosError.response.data as { message?: string }
        console.error(`Slack API error: ${axiosError.response.status} - ${errorData?.message || 'Unknown error'}`)
      } else {
        const errorMessage = error instanceof Error ? error.message : 'Unknown error'
        console.error(`Failed to send Slack notification: ${errorMessage}`)
      }
      throw error
    }
  }
}

export default Slack
